import type { PlayerId, Session, TeamId, TeamScoringType } from '@/schemas';

/**
 * Get total score for a player across all non-deleted rounds
 */
export const getTotalScore = (session: Session, playerId: PlayerId): number => {
  let total = 0;
  for (const round of session.rounds) {
    if (!round.deletedAt) {
      total += round.scores[playerId] ?? 0;
    }
  }
  return total;
};

/**
 * Get team score based on team scoring type
 */
export const getTeamScore = (
  session: Session,
  teamId: TeamId,
  _teamScoringType: TeamScoringType,
): number => {
  const team = session.teams?.find((t) => t.id === teamId);
  if (!team) return 0;

  // For MVP, both combined and individual scoring types use the same calculation
  let total = 0;
  for (const playerId of team.playerIds) {
    total += getTotalScore(session, playerId);
  }
  return total;
};
